import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import {
  MdPerson, MdEmail, MdPhone, MdBadge,
  MdSchool, MdWork, MdLocalHospital, MdAttachMoney,
} from "react-icons/md";
import doctorService from "../../Services/doctorService";

export default function Profile() {
  const doctorCookie = JSON.parse(Cookies.get("doctor") || "{}");
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await doctorService.getProfile(doctorCookie.id);
        setDoctor(res.doctor || null);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [doctorCookie.id]);

  if (loading) {
    return <div className="py-24 text-center text-gray-400 text-sm">Loading profile...</div>;
  }

  if (!doctor) {
    return <div className="py-24 text-center text-gray-400 text-sm">Profile not found</div>;
  }

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-gray-800 text-xl font-semibold">My Profile</h1>
        <p className="text-gray-400 text-sm mt-0.5">Your personal and professional details</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {/* Avatar card */}
        <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-6 flex flex-col items-center text-center">
          <div className="w-20 h-20 rounded-full bg-[#215187]/50 flex items-center justify-center mb-4">
            <span className="text-white text-3xl font-bold">
              {doctor.name?.charAt(0)?.toUpperCase()}
            </span>
          </div>
          <p className="text-gray-800 font-semibold text-lg">{doctor.name}</p>
          <p className="text-gray-400 text-sm mt-1">{doctor.specialization}</p>
         
          {doctor.pmdc_no && (
            <p className="text-xs text-gray-400 mt-3 bg-gray-50 px-3 py-1.5 rounded-lg">
              PMDC: {doctor.pmdc_no}
            </p>
          )}
        </div>

        {/* Details */}
        <div className="lg:col-span-2 space-y-4">
          <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-5">
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">Contact Information</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <ProfileField icon={<MdEmail size={16} />} label="Email" value={doctor.email} />
              <ProfileField icon={<MdPhone size={16} />} label="Phone" value={doctor.phone_no} />
            </div>
          </div>

          <div className="bg-white border border-gray-100 rounded-xl shadow-sm p-5">
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-4">Professional Details</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <ProfileField icon={<MdLocalHospital size={16} />} label="Specialization" value={doctor.specialization} />
              <ProfileField icon={<MdSchool size={16} />} label="Qualification" value={doctor.qualification} />
              <ProfileField icon={<MdWork size={16} />} label="Experience" value={doctor.experience ? `${doctor.experience} years` : "—"} />
              <ProfileField icon={<MdAttachMoney size={16} />} label="Consultation Fee" value={doctor.fee ? `Rs. ${doctor.fee}` : "—"} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProfileField({ icon, label, value }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center text-gray-500 flex-shrink-0 mt-0.5">
        {icon}
      </div>
      <div>
        <p className="text-xs text-gray-400">{label}</p>
        <p className="text-sm text-gray-700 font-medium">{value || "—"}</p>
      </div>
    </div>
  );
}